// extracted by mini-css-extract-plugin
module.exports = {"layerNote":"GetDivorced__layerNote__xQXFt"};